var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.25C9.75 8.63071 8.63071 9.75 7.25 9.75C5.86929 9.75 4.75 8.63071 4.75 7.25C4.75 5.86929 5.86929 4.75 7.25 4.75C8.63071 4.75 9.75 5.86929 9.75 7.25Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 1C10.6323 1 13.5 3.85669 13.5 7.32242C13.5 10.8433 10.5856 13.3142 7.89375 14.9943C7.69757 15.1073 7.47573 15.1667 7.25 15.1667C7.02427 15.1667 6.80243 15.1073 6.60625 14.9943C3.91937 13.2978 1 10.8555 1 7.32242C1 3.85669 3.86767 1 7.25 1Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a04a61d067db6b90fc581ae6f26b1c35.svg";
export { ForwardRef as ReactComponent };